/**
 * Tải cấu hình SSO sớm (import trong main.ts).
 */
import { loadSsoConfig } from "../helper/sso";
if (typeof window !== "undefined") {
    loadSsoConfig().catch(() => undefined);
}
